import { Entity } from '@backstage/catalog-model';
import { GLITCHTIP_HEALTH_CHECK_URL, GLITCHTIP_ERRORS_CHECK_URL, GLITCHTIP_PERFORMANCE_URL } from '../constants';

export const isHealthCheckAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[GLITCHTIP_HEALTH_CHECK_URL]);

export const isErrorsCheckAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[GLITCHTIP_ERRORS_CHECK_URL]);

export const isPerformanceAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[GLITCHTIP_PERFORMANCE_URL]);
